import * as yup from "yup";

import { Translate } from "@/redux/modules/value/translations/translations.provider";
import { Conditions } from "@/utils/validation/schemas/conditions.RHF";

export const BoxConditionsValidationSchema = yup
    .object({
        isAgeConditionRequired: yup.boolean().default(false),
        isPartnerConditionRequired: yup.boolean().default(false),
        boxConditions: yup.object({
            ageCondition: yup.boolean().optional(),
            partnerCondition: yup.boolean().optional()
        })
    })
    .test("ageConditionRequired", function (value) {
        if (!value?.isAgeConditionRequired) {
            return true;
        }

        return (
            Conditions.ageCondition.isValidSync(
                value?.boxConditions?.ageCondition
            ) ||
            this.createError({
                path: "boxConditions.ageCondition",
                message: () => () => (t: Translate) =>
                    t(
                        "checkout.customerDetails.ageCondition.validation.input.required"
                    )
            })
        );
    })
    .test("partnerConditionRequired", function (value) {
        if (!value?.isPartnerConditionRequired) {
            return true;
        }

        return (
            Conditions.partnerCondition.isValidSync(
                value?.boxConditions?.partnerCondition
            ) ||
            this.createError({
                path: "boxConditions.partnerCondition",
                message: () => () => (t: Translate) =>
                    t(
                        "checkout.customerDetails.partnerCondition.validation.input.required"
                    )
            })
        );
    });

export type BoxConditionsFormValues = yup.InferType<
    typeof BoxConditionsValidationSchema
>;
